import { render, staticRenderFns } from "./SwayOfferSocialsPanel.vue?vue&type=template&id=c9d26196&scoped=true&"
import script from "./SwayOfferSocialsPanel.vue?vue&type=script&lang=js&"
export * from "./SwayOfferSocialsPanel.vue?vue&type=script&lang=js&"
import style0 from "./SwayOfferSocialsPanel.vue?vue&type=style&index=0&id=c9d26196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d26196",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VChip,VCol,VCombobox,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VImg,VRow,VSwitch,VTextField,VTextarea})
